module.exports = __webpack_public_path__ + "img/network-wireless-signal-good-symbolic.b165b048.svg";